/* @flow strict */

import * as React from 'react';
import DataTable from 'react-data-table-component';
import { columns } from './tableHeaders/index';

type PropsType = {
  data: [],
  progressPending: boolean,
  handleShowPaymentModalOrderId: (string | number) => void,
  handleShowPaymentModal: () => void,
  handleSort: () => void,
  showPaymentModal: boolean,
  maxResultCount: number,
  setMaxResultCount: (number) => void,
  totalRows: number,
  handlePageChange: (number) => void,
  currentPage: number
};

const customStyles = {
  headCells: {
    style: {
      fontWeight: 700,
      fontSize: '1rem'
    }
  },
  tableWrapper: {
    style: {
      display: 'block',
      overflowX: 'scroll'
    }
  },
  table: {
    style: {
      display: 'table'
    }
  },
  cells: {
    style: {
      cursor: 'default'
    }
  }
};


const RefundBody = ({
  data,
  progressPending,
  handleShowPaymentModalOrderId,
  handleShowPaymentModal,
  showPaymentModal,
  handleSort,
  maxResultCount,
  setMaxResultCount,
  totalRows,
  handlePageChange,
  currentPage
}: PropsType): React.Element<'div'> => {
  const CustomLoader = (): React.Element<'div'> => (
    <div className='csspinner' style={{ width: '50px', height: '50px' }} />
  );

  const _columns = columns(showPaymentModal, handleShowPaymentModal, handleShowPaymentModalOrderId);

  return (
    <div style={{ position: 'relative', minHeight: '120px' }}>
      <div style={{ width: '100%', overflowX: 'auto', position: 'relative' }}>
        <DataTable
          columns={_columns}
          data={data}
          customStyles={customStyles}
          sortServer
          onSort={(column, sortDirection) => handleSort(`${column.selector}+${sortDirection}`)}
          defaultSortField="fname"
          highlightOnHover
          pointerOnHover
          responsive
          striped
          fixedHeader
          noHeader
          progressPending={progressPending}
          progressComponent={<CustomLoader />}
          sortIcon={(): any => (
            <>
              <span className="-sort-desc" />
              <span className="-sort-asc" />
            </>
          )}
          pagination
          paginationPerPage={maxResultCount}
          paginationServer
          paginationTotalRows={totalRows}
          paginationDefaultPage={currentPage}
          paginationRowsPerPageOptions={[100, 500, 1000]}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={setMaxResultCount}
        />
      </div>
    </div>
  );
};

export default RefundBody;
